import { CreateOrdreFabricationPage } from "@features/production/components/CreateOrdreFabricationPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { FilePlus } from "lucide-react";
import { z } from "zod";

export const Route = createFileRoute("/_app/production/ordres-fabrication/create")({
  validateSearch: z.object({
    article: z.coerce.number().optional(),
    quantite: z.coerce.number().optional(),
  }),
  loader: requirePermission(PERMISSIONS.PRODUCTION.OF.CREATE),
  staticData: {
    title: "Nouvel OF",
    icon: FilePlus,
    permission: PERMISSIONS.PRODUCTION.OF.CREATE,
    section: "App",
    showInBreadcrumb: true,
  },
  component: CreateOrdreFabricationPage,
});
